import { FooterContainer, FooterHeading, NoteItem, NotesList } from './styles'

const NOTES = [
  '본 상품은 정식 판매 상품이 아닌 나눔 목적의 비닐입니다.',
  '재고 소진 시 별도 안내 없이 조기 종료될 수 있습니다',
  '단순 변심 환불은 소비자보호법 관련 고지에 따라 불가합니다.',
]

export function FooterNotesSection() {
  return (
    <FooterContainer>
      <FooterHeading>유의사항</FooterHeading>
      <NotesList>
        {NOTES.map((note) => (
          <NoteItem key={note}>{note}</NoteItem>
        ))}
      </NotesList>
    </FooterContainer>
  )
}
